const STAGE_LABELS = ["Details", "Location", "Space", "Review", "Payment"];

export default function ProgressBar({ step }) {
  return (
    <div className="mt-8 flex items-center gap-2">
      {STAGE_LABELS.map((label, i) => (
        <div key={label} className="flex-1 flex items-center gap-2">
          <div className={`w-8 h-8 rounded-full grid place-items-center text-sm font-semibold ${step >= i ? "bg-[var(--yp-primary)] text-white" : "bg-[var(--yp-surface-alt)] text-[var(--yp-muted)]"}`}>
            {i + 1}
          </div>
          <div className="hidden sm:block text-xs text-[var(--yp-muted)]">{label}</div>
          {i < STAGE_LABELS.length - 1 && <div className="flex-1 h-px bg-[var(--yp-border)]" />}
        </div>
      ))}
    </div>
  );
}
